import { Component, Input, Output, EventEmitter, signal, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Tournament } from '../../../models';
import { SortConfig, TableSortingService } from '../../../services';
import { TablePaginationService } from '../../../services/shared/table-pagination/table-pagination.service';
import { SortableHeaderComponent } from '../../shared/sortable-header/sortable-header.component';
import { TablePaginationComponent } from '../../shared/table-pagination/table-pagination.component';

@Component({
    selector: 'app-tournament-list',
    standalone: true,
    imports: [CommonModule, SortableHeaderComponent, TablePaginationComponent],
    templateUrl: './tournament-list.component.html',
    styleUrl: './tournament-list.component.scss'
})
export class TournamentListComponent {
    @Input() set tournaments(value: Tournament[]) {
        this._tournaments.set(value);
    }
    @Input() set filteredTournaments(value: Tournament[]) {
        this._filteredTournaments.set(value);
    }

    @Output() toggleTournamentStatus = new EventEmitter<Tournament>();
    @Output() viewTournament = new EventEmitter<Tournament>();
    @Output() exportTournaments = new EventEmitter<void>();

    // Internal signals - made public for template access
    _tournaments = signal<Tournament[]>([]);
    _filteredTournaments = signal<Tournament[]>([]);
    sortConfig = signal<SortConfig | null>(null);

    // Pagination signals
    currentPage = signal<number>(1);
    pageSize = signal<number>(20);

    // Computed sorted tournaments
    sortedTournaments = computed(() => {
        const tournaments = this._filteredTournaments();
        const sort = this.sortConfig();

        if (!sort) {
            return tournaments;
        }

        return this.tableSortingService.sort(tournaments, sort.key, sort.direction);
    });

    // Computed pagination result  
    paginationResult = computed(() => {
        const sorted = this.sortedTournaments();
        const currentPageValue = this.currentPage();
        const pageSizeValue = this.pageSize();

        return this.tablePaginationService.paginate(
            sorted,
            currentPageValue,
            pageSizeValue
        );
    });

    constructor(private tableSortingService: TableSortingService, private tablePaginationService: TablePaginationService) { }

    onToggleTournamentStatus(tournament: Tournament): void {
        this.toggleTournamentStatus.emit(tournament);
    }

    onViewTournament(tournament: Tournament): void {
        this.viewTournament.emit(tournament);
    }

    onSort(event: { key: string; direction: 'asc' | 'desc' }) {
        this.sortConfig.set({ key: event.key, direction: event.direction });
    }

    onPageChange(page: number) {
        this.currentPage.set(page);
    }

    onExportTournaments(): void {
        this.exportTournaments.emit();
    }
}
